module.exports = __webpack_public_path__ + "img/icon-iot.76646823.png";